export default "__VITE_ASSET__C1A$9j_x__"